/**
 * CognitoConfig.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Single source of truth for Cognito Hosted UI configuration.
 *
 * Values are baked into the JS bundle at build time from REACT_APP_* variables
 * written to frontend/.env.production by the CI/CD workflow step
 * "🔐 Inject Cognito config into React build environment".
 *
 * SSM source: /DAP/{env}/{region}/env.variables
 *   COGNITO_USER_POOL_ID  →  REACT_APP_COGNITO_USER_POOL_ID
 *   COGNITO_CLIENT_ID     →  REACT_APP_COGNITO_CLIENT_ID
 *   COGNITO_DOMAIN        →  REACT_APP_COGNITO_DOMAIN
 *   (redirect URI is auto-derived per environment)
 * ─────────────────────────────────────────────────────────────────────────────
 */

const userPoolId  = process.env.REACT_APP_COGNITO_USER_POOL_ID  || "";
const clientId    = process.env.REACT_APP_COGNITO_CLIENT_ID     || "";
const domain      = process.env.REACT_APP_COGNITO_DOMAIN        || "";
const redirectUri = process.env.REACT_APP_COGNITO_REDIRECT_URI  || window.location.origin;

/** true only when all three required values are present in the bundle */
export const cognitoEnabled = Boolean(userPoolId && clientId && domain);

const CognitoConfig = {
  userPoolId,
  clientId,
  domain,
  redirectUri,
  /** Full Hosted UI login URL with code grant + openid/email scopes */
  loginUrl: cognitoEnabled
    ? `https://${domain}/login?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=openid+email+profile`
    : null,
};

export default CognitoConfig;
